import { getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import type { Currency, PaymentInterval } from '@core/billing-types';
import { TranslatePipe } from '@core/i18n-legacy';

import { MathPipe } from './math.pipe';

@Component({
  selector: 'rt-plan-picker-product-price',
  templateUrl: './plan-picker-product-price.component.html',
  styleUrls: ['./plan-picker-product-price.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MathPipe, TranslatePipe],
})
export class PlanPickerProductPriceComponent {
  public readonly interval = input<PaymentInterval>(undefined!);
  public readonly currency = input<Currency>(undefined!);
  public readonly costPerMonth = input<number>(undefined!);
  @Input() public costPerMonthWithoutDiscount: number;

  public currencySymbol: string;

  public ngOnChanges() {
    this.currencySymbol = getCurrencySymbol(this.currency(), 'narrow');
  }
}
